define( [
	"./arr"
], function( arr ) {
	return arr.push;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/push.js
// module id = 553
// module chunks = 349